'use client';
import React from 'react';

const PostsRelated = () => {
  return <div></div>;
};

export default PostsRelated;
